<template>
  <div class="">
    <div class="card-body">
      <form @submit.stop.prevent="exportCalls">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <label class="col-form-label">{{ $t('users.user') }}</label>
              <select class="form-control form-control-sm" v-model="filter.users" multiple="true">
                <option selected="true" value="">{{ $t('field.any') }}</option>
                <option v-for="user in users" :value="user.id" :key="user.id">
                  {{ user.lastname }} {{ user.firstname }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <button type="submit" class="btn btn-primary" name="button" :disabled="isProcessing" >
                <i class="fa fa-spinner fa-pulse fa-fw" v-if="isProcessing"></i> Выгрузить
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import downloader from "js-file-download";

export default {
  data() {
    return {
      users: [],
      contragents: [],
      filename: '',
      select_all: '',
      filter: {
        users: [],
        fields: [
          'debt.number',
          'phone',
          'fullname',
          'debtor_iin',
          'contragent.name',
          'user.fullname',
          'user.login',
        ],
      },
      errors: {},
      isProcessing: false,
    };
  },
  mounted() {
    this.getListUsers();
  },
  methods: {
    exportCalls() {
      this.isProcessing = true;
      window.axios.post('/admin/export/contacts', this.filter, {
        responseType: 'arraybuffer',
      })
          .then((res) => {
            downloader(res.data, 'contacts.xlsx')
          })
          .catch((err) => {
            this.laravelValidation(err);
          })
          .finally(() => {
            this.isProcessing = false;
          });
    },

    getListUsers() {
      window.axios.get('/admin/list/users')
        .then((res) => {
          this.users = res.data.users;
        });
    },

    toggleSelectAll() {
      const vmod = this;
      const query = 'field';
      const filters = Object.keys(this.filter).filter(key => key.toLowerCase().indexOf(query.toLowerCase()) > -1);

      if (vmod.select_all) {
        filters.forEach((filter) => {
          vmod.filter[filter] = 0;
        });
      } else {
        filters.forEach((filter) => {
          vmod.filter[filter] = 1;
        });
      }
    },
  },
};
</script>
